import { render } from "./MonthlyReportPage.html?vue&type=template&id=2049be7b&ts=true&external"
import script from "./MonthlyReportPage.vue?vue&type=script&lang=ts"
export * from "./MonthlyReportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__